import { FormattedMessage } from 'react-intl';
import background from '../../assets/bannerImg.png';
import React from 'react';
import css from './HeroContainer.module.css';
import NamedLink from '../NamedLink/NamedLink';
import { createResourceLocatorString } from '../../util/routes';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import routeConfiguration from '../../routeConfiguration';
function HeroContainer(props) {
  const { history } = props;
  return (
    <div>
      <div className={css.herosection}>
        <img src={background} alt="" />
        <div className={css.HeroContentMain}>
          <div className={css.heroComponent}>
            <p className={css.herotext}>
              <span className={css.SOSMessage}>
                <FormattedMessage id="LandingPage.descriptionSOSMessage" />{' '}
              </span>{' '}
              <FormattedMessage id="LandingPage.descriptionworkerMessage" />{' '}
              <span className={css.SOSMessage}>
                <FormattedMessage id="LandingPage.descriptionandMessage" />{' '}
              </span>
              <FormattedMessage id="LandingPage.descriptionemployerMessage" />{' '}
              <span className={css.SOSMessage}>
                <FormattedMessage id="LandingPage.descriptionpossiblitiesrMessage" />
              </span>
            </p>

            <div className={css.herobuttons}>
              {/* <NamedLink name="LookingForStaff"> */}
              <span
                className={css.staff}
                onClick={e => {
                  e.stopPropagation();
                  history.push(
                    createResourceLocatorString('LookingForStaff', routeConfiguration(), {}, {})
                  );
                }}
              >
                {' '}
                <FormattedMessage id="LandingPage.buttonStaffMessage" />
              </span>
              {/* </NamedLink> */}
              {/* <NamedLink name="LookingForWork"> */}
              <span
                className={css.work}
                onClick={e => {
                  e.stopPropagation();
                  history.push(
                    createResourceLocatorString('LookingForWork', routeConfiguration(), {}, {})
                  );
                }}
              >
                {' '}
                <FormattedMessage id="LandingPage.buttonWorkMessage" />
              </span>
              {/* </NamedLink> */}
            </div>
            <p className={css.accLogin_text}>
              <FormattedMessage id="LandingPage.alreadyAccountMessage" />
              {/* <span className={css.accLogin_text1}>
              {' '} */}
              <span
                className={css.login}
                onClick={e => {
                  e.stopPropagation();
                  history.push(
                    createResourceLocatorString('LoginPage', routeConfiguration(), {}, {})
                  );
                }}
              >
                {' '}
                <FormattedMessage id="LandingPage.logInMessage" />{' '}
              </span>{' '}
              {/* </span>{' '} */}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default compose(withRouter)(HeroContainer);
